import React, { useState } from 'react';
import axios from 'axios';

const AdminForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    aadharNumber: '',
    district: '',
    password: '',
    RetypePassword: '',
    role: 'admin',
    referralid: localStorage.getItem('UserId') 
  });

  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password validation
    if (formData.password !== formData.RetypePassword) {
      setErrorMessage('Passwords do not match');
      return;
    }

    // Phone number validation (only digits, exactly 10 digits)
    if (!/^\d{10}$/.test(formData.phoneNumber)) {
      setErrorMessage('Phone number must be exactly 10 digits');
      return;
    }

    // Aadhar validation (exactly 12 digits)
    if (!/^\d{12}$/.test(formData.aadharNumber)) {
      setErrorMessage('Aadhar number must be exactly 12 digits');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/add/form`, formData);
      alert('Form submitted successfully');
      console.log('Form submitted successfully:');

      setFormData({
        name: '',
        phoneNumber: '',
        email: '',
        aadharNumber: '',
        district: '',
        password: '',
        RetypePassword: '',
        // role: 'admin',
        referralid: localStorage.getItem('UserId') 
      });
      // console.log('',localStorage.getItem('UserId'))
      setErrorMessage('');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
      console.error('Error submitting the form:', error);
    }
  };

  const districts = [
    "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", 
    "Erode", "Kancheepuram", "Kanniyakumari", "Karur", "Madurai", 
    "Nagapattinam", "Namakkal", "The Nilgiris", "Perambalur", "Pudukottai", 
    "Ramanathapuram", "Salem", "Sivagangai", "Thanjavur", "Theni", 
    "Thiruvallur", "Thiruvannamalai", "Thiruvarur", "Thoothukudi", 
    "Tiruchirappalli", "Tirunelveli", "Vellore", "Villupuram", "Virudhunagar", 
    "Ariyalur", "Krishnagiri", "Tiruppur", "Chengalpattu", "Kallakurichi", 
    "Ranipet", "Tenkasi", "Tirupathur", "Mayiladuthurai"
  ];

  return (
    <div style={{ height: '100vh', backgroundColor: 'rgb(182 176 217 / 95%)' }}>
      <div className='admin_header' >
        <div className='admin_header_logo'></div>
        <div className='admin_header_text' >
          <h2>தமிழ்நாடு ராம்ஜி கல்வி மற்றும் பொருளாதார மேம்பாட்டு அறக்கட்டளை , பதிவு எண்: 38/2015</h2>
        </div>
      </div>

      {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '50%', justifyContent: 'center', alignItems: 'center' }}>
          <input type="text" id="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
          <input type="text" id="phoneNumber" placeholder="Phone Number" maxLength={10} value={formData.phoneNumber} onChange={(e) => { const newValue = e.target.value.replace(/[^0-9]/g, ''); setFormData((prevData) => ({ ...prevData, phoneNumber: newValue })); }} required />
          <input type="email" id="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="text" id="aadharNumber" placeholder="Aadhar Number" maxLength={12} value={formData.aadharNumber} onChange={(e) => { const newValue = e.target.value.replace(/[^0-9]/g, ''); setFormData((prevData) => ({ ...prevData, aadharNumber: newValue })); }} required />
          <select id="district" value={formData.district} onChange={handleChange} required>
            <option value="">Select a district</option>
            {districts.map((district, index) => (<option key={index} value={district}>{district}</option>))}
          </select>
          <input type="password" id="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
          <input type="password" id="RetypePassword" placeholder="Retype Password" value={formData.RetypePassword} onChange={handleChange} required />
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          <button type="submit">Submit</button>
        </form>
      </div> */}


<div className="form-container">
  <form onSubmit={handleSubmit}>
    <input type="text" id="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
    <input type="text" id="phoneNumber" placeholder="Phone Number" maxLength={10} value={formData.phoneNumber} 
      onChange={(e) => { 
        const newValue = e.target.value.replace(/[^0-9]/g, ''); 
        setFormData((prevData) => ({ ...prevData, phoneNumber: newValue })); 
      }} required 
    />
    <input type="email" id="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
    <input type="text" id="aadharNumber" placeholder="Aadhar Number" maxLength={12} value={formData.aadharNumber} 
      onChange={(e) => { 
        const newValue = e.target.value.replace(/[^0-9]/g, ''); 
        setFormData((prevData) => ({ ...prevData, aadharNumber: newValue })); 
      }} required 
    />
    <select id="district" value={formData.district} onChange={handleChange} required>
      <option value="">Select a district</option>
      {districts.map((district, index) => (
        <option key={index} value={district}>{district}</option>
      ))}
    </select>
    <input type="password" id="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
    <input type="password" id="RetypePassword" placeholder="Retype Password" value={formData.RetypePassword} onChange={handleChange} required />
    {errorMessage && <p className="error-message">{errorMessage}</p>}
    <button type="submit">Submit</button>
  </form>
</div>

    </div>
  );
};

export default AdminForm;
